const contributorsItems = document.querySelectorAll('.contributors-group-item');
const searchInput = document.querySelector('[name="search_contributor"]');

searchInput?.addEventListener('input', function () {
    const searchValue = this.value.trim().toLowerCase();

    contributorsItems.forEach(item => {
        const contributorName = item.querySelector('input[name="contributor_name"]')?.value.toLowerCase() || '';

        if (contributorName.includes(searchValue) || searchValue === '') {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
});